<script>
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';
import XDivider from '@/components/common/Divider.vue';

export default {
  name: 'EligibilitySSO',

  components: {
    SwordButtonWuk,
    XDivider,
  },

  props: {
    ssoName: {
      type: String,
      required: true,
    },
    ssoUrl: {
      type: String,
      required: true,
    },
  },

  methods: {
    goToSSoRedirect() {
      this.$router.push({
        name: 'SSORedirect',
        query: { ssoUrl: this.ssoUrl },
        params: { ssoName: this.ssoName },
      });
    },
  },
};
</script>

<template>
  <div class="sso-wrapper">
    <sword-button-wuk
      class="-ml_0 -mr_0"
      :text="$t('eco_create_acc_with_sso', { 'SSO name': ssoName })"
      theme="secondary"
      @click.native="goToSSoRedirect"
    />

    <x-divider :label="$t('eco_separator_enter_your_info')" class="login-divider"></x-divider>
  </div>
</template>

<style lang="scss" scoped>
.sso-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-bottom: 2rem;
}
</style>
